import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./i18n";
import "./styles/index.css";

import { App } from "./app/App";

const root = document.getElementById("root");
if (!root) throw new Error("#root element is missing");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
